<template>
  <el-upload class="avatar-uploader"
             :name="file_name"
             :action="$ip + '/add_image?key_name=upload_image'"
             :show-file-list="false"
             :with-credentials="true"
             :on-success="handleAvatarSuccess"
             :before-upload="beforeAvatarUpload"
             :accept="accept">
    <img v-if="imageUrl"
         :src="imageUrl"
         class="avatar" />
    <i v-else
       class="el-icon-plus avatar-uploader-icon"></i>
  </el-upload>
</template>

<script>
export default {
  name: 'up-load',
  data() {
    return {
      file_name: 'image',
      imageUrl: this.default_image, // 上传图片框 处 的 图片链接， 通过v-if判断，如果有则显示图片，如果没有则不显示图片
      image_url: '', // 返回的图片链接
      accept: this.accept_format,
    }
  },
  props: {
    accept_format: {
      type: String,
      default: '.jpg, .jpeg, .png, .gif',
    },
    default_image: {
      type: String,
      default: '',
    },
  },
  watch: {
    default_image(newValue) {
      this.imageUrl = newValue
    },
  },
  methods: {
    beforeAvatarUpload(file) {
      // console.log(file);
      const isFORMAT =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/gif'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isFORMAT) {
        this.$message.error(`上传头像图片只能是 ${accept_format} 格式!`)
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      //   console.log(file);
      return isFORMAT && isLt2M
    },

    // 【上传成功】时的钩子函数，将返回值添加到页面中
    handleAvatarSuccess(res, file) {
      if (res.errno == '4101' || res.errno == '4602') {
        this.$notify({
          title: '警告',
          message: res.errmsg,
          type: 'warning',
        })
        return
      } else if (res.errno == '0') {
        this.image_url = res.data.image_url
        this.imageUrl = URL.createObjectURL(file.raw) // 让图片可以展示在前端
        // 发送事件给父组件
        console.log(this.image_url)
        this.$emit('getImageURl', this.image_url)
      }
    },
  },
}
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>